import * as types from "./mutation-types";


const updateProfile = async ({dispatch,commit}, obj) => {
  const {data: {user}} = await axios.put(`${process.env.API_PATH}/user/profile`, obj)
  dispatch('setUser', user, { root: true })
}

const setMe = async ({commit}, obj) => {
  const user = (await axios.get(`${process.env.API_PATH}/user/me`)).data
  commit(types.SET_ME, {user})
}

const setList = async ({commit}, obj) => {
  const list = (await axios.get(`${process.env.API_PATH}/user`)).data
  commit(types.SET_LIST, {list})
}

const setSelected = async ({commit}, obj) => {
  const _user = (await axios.get(`${process.env.API_PATH}/user/${obj.userId}`)).data
  commit(types.SET_SELECTED, {_user})
}

const createNew = async ({commit}, user) => {
  const newUser = (await axios.post(`${process.env.API_PATH}/user`, user)).data
  commit(types.SET_NEW, {newUser})
}

const update = async ({commit}, user) => {
  const updatedUser = (await axios.put(`${process.env.API_PATH}/user/${user.id}`, user)).data
  commit(types.SET_UPDATED, {updatedUser})
}

export default {
  setMe, setList, createNew, setSelected, update, updateProfile
}



// WEBPACK FOOTER //
// ./src/features/User/store/actions.js